'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutGrid, Code, Briefcase, GraduationCap, Palette, MessageSquare, MessageCircle, Heart, Lightbulb, BookOpen, Music, Camera, Globe, Rocket, Shield, Zap, Megaphone, Scale, PenTool, BarChart2, Send, Search, Phone, Mail, Wallet, Users, Sparkles, Bot, Target, ShoppingCart, Video, BadgeDollarSign, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
const ICON_MAP: Record<string, LucideIcon> = {
  'layout-grid': LayoutGrid,
  layout: LayoutGrid,
  code: Code,
  briefcase: Briefcase,
  'graduation-cap': GraduationCap,
  palette: Palette,
  'message-square': MessageSquare,
  'message-circle': MessageCircle,
  heart: Heart,
  lightbulb: Lightbulb,
  'book-open': BookOpen,
  music: Music,
  camera: Camera,
  globe: Globe,
  rocket: Rocket,
  shield: Shield,
  zap: Zap,
  megaphone: Megaphone,
  scale: Scale,
  'pen-tool': PenTool,
  'bar-chart-2': BarChart2,
  send: Send,
  search: Search,
  phone: Phone,
  mail: Mail,
  wallet: Wallet,
  users: Users,
  sparkles: Sparkles,
  bot: Bot,
  target: Target,
  'shopping-cart': ShoppingCart,
  video: Video,
  'badge-dollar-sign': BadgeDollarSign
};
interface SpaceIconProps {
  name: string | null | undefined;
  className?: string;
}
export function SpaceIcon(t0) {
  const $ = _c(9);
  const {
    name,
    className
  } = t0;
  const Icon = name ? ICON_MAP[name] : null;
  if (!Icon) {
    let t1;
    if ($[0] !== className) {
      t1 = cn("w-5 h-5", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <Bot className={t1} />;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn("w-5 h-5", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== Icon || $[7] !== t1) {
    t2 = <Icon className={t1} />;
    $[6] = Icon;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}